import axios from 'axios';
import { useState } from 'react';

import { unpauseSurvey } from '@api/surveys';
import { Announcement, Button, ModalV2 as Modal } from '@utilities';

interface ResumeModalProps {
  id: number;
  onClose: () => void;
  onSubmit: () => void;
}

const ResumeModal = ({ id, onClose, onSubmit }: ResumeModalProps) => {
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async () => {
    setError('');
    setIsLoading(true);

    try {
      await unpauseSurvey({
        id,
      });
      onSubmit();
    } catch (error) {
      const defaultErrorMessage = 'An unexpected error occurred. Please try again.';
      if (axios.isAxiosError(error) && error.response) {
        setError(error?.response.data?.error || defaultErrorMessage);
      } else {
        setError(defaultErrorMessage);
      }
      setIsLoading(false);
    }
  };

  return (
    <Modal
      buttons={[
        <Button key="cancel-btn" onClick={onClose} text="Cancel" variant="secondary" />,
        <Button
          isLoading={isLoading}
          key="continue-btn"
          onClick={handleSubmit}
          text="Continue"
          variant="primary"
        />,
      ]}
      isActive
      onClose={onClose}
      title="Resume Survey"
    >
      {error && <Announcement text={error} variant="error" />}

      <p>This action will set the survey live to panelists again.</p>
      <br />
      <p>Do you wish to continue?</p>
    </Modal>
  );
};

export default ResumeModal;
